
import { defineComponent, ref } from 'vue';
import Dialog from 'primevue/dialog';
import IntegrationConfig from '@/views/shop/IntegrationConfig.vue';
import type { Integration } from '@/composables/useIntegrations';

export default defineComponent({
  name: 'IntegrationConfigModal',

  components: {
    Dialog,
    IntegrationConfig,
  },

  emits: ['done'],

  setup(_, { emit, expose }) {
    const isVisible = ref(false);
    const slug = ref('');
    const name = ref('');
    const icon = ref('');

    /** Open the config modal for a given (installed) integration. */
    const open = (integration: Integration) => {
      slug.value = integration.slug;
      name.value = integration.name || '';
      icon.value = integration.icon_url || '';
      isVisible.value = true;
    };

    /** Close without signalling completion (cancel). */
    const close = () => {
      isVisible.value = false;
    };

    /** Configuration finished successfully → tell the parent to refresh. */
    const onDone = () => {
      isVisible.value = false;
      emit('done');
    };

    /** Reset transient state once the dialog is fully hidden. */
    const onHide = () => {
      slug.value = '';
      name.value = '';
      icon.value = '';
    };

    expose({ open });

    return {
      isVisible,
      slug,
      name,
      icon,
      close,
      onDone,
      onHide,
    };
  },
});
